import React from "react";

// Subtle telemetry crosshairs at the 4 corners of a container. Purely decorative HUD cue.
export default function HudFrame({ color = "rgba(255,255,255,0.18)", className = "", children, size = 10 }) {
  const corner = (pos) => {
    const base = { position: "absolute", width: size, height: size, pointerEvents: "none" };
    const b = `1px solid ${color}`;
    if (pos === "tl") return { ...base, top: -1, left: -1, borderTop: b, borderLeft: b };
    if (pos === "tr") return { ...base, top: -1, right: -1, borderTop: b, borderRight: b };
    if (pos === "bl") return { ...base, bottom: -1, left: -1, borderBottom: b, borderLeft: b };
    return { ...base, bottom: -1, right: -1, borderBottom: b, borderRight: b };
  };
  return (
    <div className={`relative ${className}`}>
      <span style={corner("tl")} />
      <span style={corner("tr")} />
      <span style={corner("bl")} />
      <span style={corner("br")} />
      {children}
    </div>
  );
}
